/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetConnectionByIdQueryResponse, SocialExportGetConnectionByIdPathParams, SocialExportGetConnectionById401, SocialExportGetConnectionById403, SocialExportGetConnectionById404 } from "../models/SocialExportGetConnectionById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetConnectionById } from "../axios/socialExportGetConnectionById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetConnectionByIdQueryKey = (id: SocialExportGetConnectionByIdPathParams["id"]) => ["api-v2", { url: '/social-export/v1/connections/:id', params: {id:id} }] as const

export type SocialExportGetConnectionByIdQueryKey = ReturnType<typeof socialExportGetConnectionByIdQueryKey>

export function socialExportGetConnectionByIdQueryOptions(id: SocialExportGetConnectionByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetConnectionByIdQueryKey(id)
        return queryOptions<SocialExportGetConnectionByIdQueryResponse, ResponseErrorConfig<SocialExportGetConnectionById401 | SocialExportGetConnectionById403 | SocialExportGetConnectionById404>, SocialExportGetConnectionByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetConnectionById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns connection state, profile info, and linked station IDs for a single connection.
 * @summary Get a connection by id
 * {@link /social-export/v1/connections/:id}
 */
export function useSocialExportGetConnectionById<TData = SocialExportGetConnectionByIdQueryResponse, TQueryData = SocialExportGetConnectionByIdQueryResponse, TQueryKey extends QueryKey = SocialExportGetConnectionByIdQueryKey>(id: SocialExportGetConnectionByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetConnectionByIdQueryResponse, ResponseErrorConfig<SocialExportGetConnectionById401 | SocialExportGetConnectionById403 | SocialExportGetConnectionById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetConnectionByIdQueryKey(id)
         

         const query = useQuery({
          ...socialExportGetConnectionByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetConnectionById401 | SocialExportGetConnectionById403 | SocialExportGetConnectionById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}